<template>
	<div class="login_container">
		<div class="login_box">
			<!-- 头像区 -->
			<div class="avatar_box">
				<img src="../assets/logo.png" alt="avatar" />
			</div>
			<!-- 登录表单 -->
			<div>
				<el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="60px" class="login_form">
					<el-form-item label="账号" prop="username">
						<el-input v-model="loginForm.username" prefix-icon="iconfont icon-user"></el-input>
					</el-form-item>
					<el-form-item label="密码" prop="password">
						<el-input v-model="loginForm.password" type="password" prefix-icon="iconfont icon-3702mima"></el-input>
					</el-form-item>
					<el-form-item class="btns">
						<el-button type="primary" @click="login">登录</el-button>
						<el-button type="info" @click="resetLoginForm">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loginForm: {
					username: 'admin',
					password: ''
				},
				// 表单验证
				loginFormRules: {
					username: [{
							required: true,
							message: '请输入用户名',
							trigger: 'blur'
						},
						{
							min: 2,
							max: 10,
							message: '长度在 2 到 10 个字符',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入用户密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 18,
							message: '长度在 6 到 18 个字符',
							trigger: 'blur'
						}
					]
				}
			}
		},
		methods: {
			// 表单重置按钮
			resetLoginForm() {
				// console.log(this)
				// resetFields：element-ui提供的表单方法
				this.$refs.loginFormRef.resetFields()
			},
			login() {
				console.log('点击了登录')
				console.log(JSON.stringify(this.loginForm))
				// 表单预验证
				// valid：bool类型
				this.$refs.loginFormRef.validate(async valid => {
					// console.log(valid)
					if (!valid) return false
					// this.$http.post('login', this.loginForm): 返回值为promise
					// 返回值为promise，可加await简化操作 相应的也要加async
					const res = await this.$http.post('/v1/user/login/password', {
						request:{
							username:this.loginForm.username,
							password:this.loginForm.password
						}
					})
					console.log(JSON.stringify(this.loginForm))
					console.log(JSON.stringify(res))
					 if (res.data.code !== 0) return this.$message.error(res.data.message)
					 if(res.data.code == 0){
						 this.$message.success('登录成功');
						 window.sessionStorage.setItem('jiuhangtoken', res.data.data);
						 // 2、通过编程式导航跳转到后台主页, 路由地址为：/home
						 this.$router.push('/home');
					 }
					
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	/* // lang="less" 支持less格式
// scoped vue的指令，只在当前组件生效 */
	.login_container {
		background-color: #2b4b6b;
		height: 100%;
	}

	.login_box {
		width: 450px;
		height: 360px;
		background-color: #fff;
		border-radius: 3px;
		position: absolute;
		left: 50%;
		top: 50%;
		-webkit-transform: translate(-50%, -50%);
		background-color: #fff;

		.avatar_box {
			width: 200px;
			height: 80px;
			border: 1px solid #eee;
			/* border-radius: 10%; */
			padding: 10px;
			box-shadow: 0 0 10px #ddd;
			position: absolute;
			left: 50%;
			transform: translate(-50%, -50%);
			background-color: #2361AC;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	.login_form {
		position: absolute;
		bottom: 60px;
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.btns {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.info {
		font-size: 13px;
		margin: 10px 15px;
	}
</style>
